module.exports = __webpack_public_path__ + "img/icon14.1966023a.png";